import { html } from "lit";
var icon_home_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M26 15.672l2 1.572V29l-8-.001V29h-8v-.001L4 29V17.244l2-1.572v11.327h6V20a3 3 0 012.824-2.995L15 17h2a3 3 0 013 3v6.999h6V15.672zM17 19h-2a1 1 0 00-1 1v6.999h4V20a1 1 0 00-.883-.993L17 19zm-.502-15.867l.112.074 13 10a1 1 0 01-1.115 1.656l-.105-.07L16 5.26 3.61 14.793a1 1 0 01-1.32-.089l-.083-.094a1 1 0 01.089-1.32l.094-.083 13-10a1.002 1.002 0 011.108-.074z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_home_default as default
};
//# sourceMappingURL=icon-home.js.map
